"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submitButtonMessages = void 0;
var _reactIntl = require("react-intl");
var submitButtonMessages = (0, _reactIntl.defineMessages)({
  adyenButtonLabel: {
    id: 'submitButton.adyen.label',
    description: 'Submit button label of Adyen',
    defaultMessage: 'Pay Now'
  }
});
exports.submitButtonMessages = submitButtonMessages;